// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Rfsi","options":"AnswerScale_options__202Wr","selected":"AnswerScale_selected__1isGk"};